/**
 * Employee query key factory
 * Provides type-safe and hierarchical query keys for all employee-related queries
 */
export const employeeKeys = {
  // Base key for all employee data
  all: ["employees"] as const,

  // All employee lists
  lists: () => [...employeeKeys.all, "list"] as const,
  list: () => [...employeeKeys.lists()] as const,

  // Individual employees
  details: () => [...employeeKeys.all, "detail"] as const,
  detail: (id: string) => [...employeeKeys.details(), id] as const,
} as const;
